<div
  class="component-container"
  data-cy="won_message"
  [style.backgroundColor]="config().backgroundColor"
>
  <div
    class="right"
    [style.backgroundImage]="
      config().right.backgroundImage.imageUrl | transformUrl
    "
  >
    <div
      class="amount"
      [style]="{
        color: config().right.amount.color,
        fontFamily: config().right.amount.fontFamily,
      }"
    >
      {{ amount() | formatReward }}
    </div>
  </div>
  <div class="left">
    <img
      alt=""
      class="left-image"
      [src]="config().left.backgroundImage.imageUrl"
    />

    <div
      class="win-first-label"
      [style]="{
        color: config().left.winFirstLabel.color,
        fontFamily: config().left.winFirstLabel.fontFamily,
      }"
    >
      {{ config().left.winFirstLabel.text }}
    </div>
    <div
      class="win-second-label"
      [style]="{
        color: config().left.winSecondLabel.color,
        fontFamily: config().left.winSecondLabel.fontFamily,
      }"
    >
      {{ config().left.winSecondLabel.text }}
    </div>
  </div>
</div>
